import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        message: String
    }

    change(event) {
        // ON → OFF のときだけ確認
        if (!event.target.checked) {
            const ok = window.confirm(this.messageValue)

            if (!ok) {
                event.target.checked = true
            }
        }
    }
}